module.exports = __webpack_public_path__ + "static/img/copper_board_type.1587d9a6.png";